// extracted by mini-css-extract-plugin
export var container = "_6m-0";
export var containerTopRight = "_6m-1";